import { useEffect, useRef } from 'react';

export type ExcludeHandlerProps = {
	/**
	 * Optional callback fired when the user is excluded by this component.
	 * Useful for performing side-effects such as analytics, logging, or marking exclusion in state.
	 */
	onExclude?: () => void;
};

/**
 * A reusable component that handles exclusion side effects.
 * Ensures the onExclude callback is only fired once per component lifecycle.
 */
export const ExcludeHandler = ({ onExclude }: ExcludeHandlerProps) => {
	const hasFiredRef = useRef(false);

	useEffect(() => {
		if (!hasFiredRef.current) {
			hasFiredRef.current = true;
			onExclude?.();
		}
	}, [onExclude]);

	return null;
};
